// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__Ujiw2","material-symbols-outlined":"Header_material-symbols-outlined__KlfGh","material-symbols-rounded":"Header_material-symbols-rounded__+HfF3"};